var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNorthKorea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.001C24.8366 32.001 32 24.8375 32 16.001C32 7.16442 24.8366 0.000976562 16 0.000976562C7.16344 0.000976562 0 7.16442 0 16.001C0 24.8375 7.16344 32.001 16 32.001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 0.000976562C11.1502 0.000976562 6.80504 2.15873 3.87085 5.56616H28.1284C25.1943 2.15873 20.8491 0.000976562 15.9997 0.000976562V0.000976562Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1285 26.4358H3.87085C6.80504 29.8432 11.1502 32.001 15.9997 32.001C20.8491 32.001 25.1943 29.8432 28.1285 26.4358Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6516 7.65308H2.34838C0.859063 10.0834 0 12.9417 0 16.0009C0 19.0601 0.859063 21.9185 2.34838 24.3487H29.6516C31.1409 21.9185 32 19.0601 32 16.0009C32 12.9417 31.1409 10.0834 29.6516 7.65308Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84327 22.1574C13.2434 22.1574 15.9998 19.401 15.9998 16.0009C15.9998 12.6007 13.2434 9.84436 9.84327 9.84436C6.44313 9.84436 3.68677 12.6007 3.68677 16.0009C3.68677 19.401 6.44313 22.1574 9.84327 22.1574Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84396 9.84436L11.2253 14.0957H15.7027L12.0791 16.7233L13.4712 20.9873L9.84396 18.3472L6.22221 20.9824L7.60884 16.7233L3.98853 14.0957H8.46259L9.84396 9.84436Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorthKorea);
export default __webpack_public_path__ + "static/media/north-korea.6f2d8e2e.svg";
export { ForwardRef as ReactComponent };